const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox
    image.src = url;
  });

/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 * @param {File} image - Image File url
 * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
 */
export default async function getCroppedImg(imageSrc, pixelCrop) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(
    image,
    pixelCrop?.x,
    pixelCrop?.y,
    pixelCrop?.width,
    pixelCrop?.height,
    0,
    0,
    pixelCrop?.width,
    pixelCrop?.height
  );

  // Ahora redimensionamos a 600x450 en otro canvas
  const targetWidth = 600;
  const targetHeight = 450;
  const finalCanvas = document.createElement("canvas");
  finalCanvas.width = targetWidth;
  finalCanvas.height = targetHeight;
  const finalCtx = finalCanvas.getContext("2d");

  finalCtx.drawImage(canvas, 0, 0, targetWidth, targetHeight);

  // As Base64 string
  // return canvas.toDataURL("image/jpeg");
  return new Promise((resolve, reject) => {
    finalCanvas.toBlob(
      (blob) => {
        if (blob) {
          resolve({
            blob,
            base64: finalCanvas.toDataURL("image/jpeg"),
          });
        } else {
          reject(new Error("Failed to create blob"));
        }
      },
      "image/jpeg",
      1
    );
  });
}
